<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <dealHeader :deal="deal" :deal_contact="deal_contact" :stages="stages" :company_users="company_users" :deal_activities="deal_activities"></dealHeader>
        <div class="row">
          <div class="col-md-4">
            <div class="content-side-bar">
              <div class="row">
                <div class="col-md-12">
                  <div class="widget-wrap">
                    <div class="deal_sidebar block-header clearfix">
                      <div class="pull-left">
                        <p>交易資訊</p>
                      </div>
                      <div class="pull-right">
                      </div>
                    </div>
                    <div class="widget-container">
                      <div class="widget-content text-left">
                        <div class="row">
                          <div class="col-md-12 deal_page_sidebar_content pointer">
                          	<div>
	                            <span @click="ShowContact(deal_contact.contact_token)">{{deal_contact.name}}</span>
	                            <a @click="changeContactModal=true" class="row-edit"><span class="zmdi zmdi-edit pointer"></span></a>
	                            <span class="pointer" v-show="deal.edit=='no' || deal.edit!=deal.deal_organization_name" @click="ShowOrganization(deal.deal_organization_token)"> - {{deal.deal_organization_name}}</span>
	                            <span class="pointer" v-if="deal.deal_organization_name==''||deal.deal_organization_name==null" v-show="deal.edit=='no' || deal.edit!=deal.deal_organization_name" @click="ShowOrganization(deal.deal_organization_token)"> - 無所屬公司</span>
	                          </div>
	                          <div>交易建立時間：{{ deal.created_at }}</div>
	                          <div v-if="deal.deal_status == 'won'">
	                          	<datepicker input-class="form-control" language="zh" style="width:150px;display:inline-block"
	                          		v-model="deal.deal_time" 
							                  v-if="canEditColumn('deal_time',deal.deal_token)"
	                          		@selected="dateSelected()" 
	                          		:format="'yyyy/MM/dd'">
	                          	</datepicker>
	                          	
											    		<span v-else @click="editColumn('deal_time',deal.deal_token)" class="pointer">
											    			交易完成時間：{{customFormatter(deal.deal_time)}} <i class="fa fa-pencil-alt"></i>
											    		</span>

	                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="widget-wrap">
                    <div class="deal_sidebar block-header clearfix">
                      <div class="pull-left">
                        <p>報價單</p>
                      </div>
                      <div class="pull-right">
                        <a @click="loadingQuotation();CreateQuotation()" class="row-edit"><i class="fa fa-plus"></i></a>
                      </div>
                    </div>
                    <div id="quotation_box" class="widget-container v-step-6-8">
                      <div class="widget-content">
                        <p v-for="quotation in quotations" class="single_quotation" :id="quotation.quotation_token">
                          <span v-if="quotation.is_draft">
                            草稿 - {{quotation.quotation_title}}
                          </span>
                          <span v-else>
                            {{quotation.quotation_title}}
                          </span>
                          <button v-if="quotation.is_draft" @click="ShowQuotation(quotation.quotation_token)" class="btn btn-xs btn-warning"><i class="fa fa-pencil-alt"></i></button>
                          <button v-if="quotation.is_draft" @click="deleteQuotationModal=true;delete_quotation=quotation" class="btn btn-xs btn-danger"><i class="fa fa-trash"></i></button>               
                          <a v-if="!quotation.is_draft" v-bind:href=" axios.defaults.baseURL +'/pdf_generators/quotation.html?quotation_token='+ quotation.quotation_token" target="_blank" class="btn btn-xs btn-success"><i class="fa fa-search"></i></a>
                          <a v-if="!quotation.is_draft" v-bind:href="axios.defaults.baseURL +'/pdf_generators/quotation.pdf?quotation_token='+ quotation.quotation_token" target="_blank" class="btn btn-xs btn-info">PDF</a>
                          <button v-if="!quotation.is_draft" @click="copyQuotationWording(quotation);copyQuotation(quotation)" class="btn btn-xs btn-warning"><i class="fa fa-copy"></i></button>
                        </p>
                        <div class="text-center" v-if="quotations.length == 0">
                            <button class="btn btn-success" v-on:click="loadingQuotation();CreateQuotation()"><i class="fa fa-plus"></i> 建立空白報價單</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <activitiesResource class="v-step-6-7" :activities="deal_activities" :activity_categories="activity_categories"></activitiesResource>
            </div>
          </div>
          <div class="col-md-8 v-step-6-6">   
            <div class="material-table-widget dashboard_top_bar">
              <a href="#" @click="loadingQuotation();CreateQuotation()" class="btn btn-default v-step-6-2"><i class="fa fa-plus"></i> 報價單</a>
              <a href="#" @click="temp_activity.content_type = 'note';showNoteModal=true" class="btn btn-default v-step-6-3"><i class="fa fa-plus"></i> 留言</a>
              <a href="#" @click="temp_activity.content_type = 'event';showActivityModal=true" class="btn btn-default v-step-6-4"><i class="fa fa-plus"></i> 待辦事項</a>
              <a href="#" @click="temp_activity.content_type = 'attachment';showUploadModal=true" class="btn btn-default v-step-6-5"><i class="fa fa-plus"></i> 檔案</a>
              <div class="pull-right">
                <button class="btn btn-success" v-if="deal.deal_status=='open'" v-on:click="deal.deal_status='won';update_deal_status(1)">獲得交易</button>
                <button class="btn btn-danger" v-if="deal.deal_status=='open'" v-on:click="deal.deal_status='lost';update_deal_status(2)">失去交易</button>
                <button class="btn btn-warning" v-if="deal.deal_status!='open'" v-on:click="deal.deal_status='open';update_deal_status(0)">重啟交易</button>
              </div>
            </div>         
            <history :activities="deal_activities" :activity_categories="activity_categories"></history>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start-->
    <div v-if="changeContactModal" @keydown.esc="changeContactModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="changeContactModal=false">
          <div class="modal-container col-md-8" @click.stop>
            <div class="modal-header">
              <div name="header">
                變更聯絡人 - 請輸入已存在的聯絡人名稱
              </div>
              <a class="btn-close" @click="changeContactModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body" style="overflow:initial">
              <div class="row j-forms">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-user"></i></label>
                      <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="organization_name" param="keyword" name="autocomplete" placeholder="聯絡人*" v-model="deal_contact_name" :classes="{ input: 'form-control  deal_contact_name', wrapper: 'input-wrapper'}" :process="process_contact_JSON" :onSelect="handle_contact_Select" :onInput="set_contact_Value" :customHeaders=auth_token :customParams="{ type: 'contact' }">
                      </autocomplete>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-primary" @click="updateDealContact(deal.deal_token)">
                  變更
                </button>
                <button class="btn btn-primary" @click="changeContactModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="deleteQuotationModal" @keydown.esc="deleteQuotationModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="deleteQuotationModal=false">
          <div class="modal-container col-md-4" @click.stop>
            <div class="modal-header">
              <div name="header">
                <h5>刪除報價單</h5>
              </div>
              <a href="#" class="btn-close" @click="deleteQuotationModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <div class="row j-forms">
                <div class="col-md-12">
                  <p>你確定要刪除這個報價單嗎？編號：{{delete_quotation.latest_date}}</p>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button class="btn btn-danger" @click="deleteQuotationDraft(delete_quotation)">
                  刪除
                </button>
                <button class="btn btn-default" @click="deleteQuotationModal=false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!-- modal template start-->
    <div v-if="showNoteModal" @keyup.esc="showNoteModal=false;">
      <div class="modal-mask">
        <div class="modal-wrapper " @click="showNoteModal=false;">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <div class="widget-header margin-bottom-0 clearfix">
                  <h4>新增留言</h4>
                </div>
              </div>
              <a href="#" class="btn-close" @click="showNoteModal=false;">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body scroll j-forms">
              <div class="form-content">
                <div class="unit">
                  <div class="input">
                    <label for="textarea">
                    </label>
                    <textarea v-autosize="temp_activity.content" rows="3" class="bootstrap_textarea" style="width:100%" placeholder="新增留言內容" v-model="temp_activity.content" @keydown="content_type='note'"></textarea>
                    <br>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-right">
              <button class="btn btn-info primary-btn" @click="add_activity">新增</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="showActivityModal" @keyup.esc="showActivityModal=false;">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showActivityModal=false;">
          <div class="modal-container modal-center col-md-8" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <div class="widget-header margin-bottom-0 clearfix">
                  <h4>新增待辦事項</h4>
                </div>
              </div>
              <a href="#" class="btn-close" @click="showActivityModal=false;">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms noscroll">
              <div class="j-forms">
                <div class="text-left form-group">
                  <div class="btn-group" role="group" aria-label="...">
                    <button v-for="category in activity_categories" type="button" class="btn btn-default" @click="temp_activity.activity_category_id=category.id" :class="{active: temp_activity.activity_category_id === category.id}"><i v-bind:class="category.icon"></i> {{category.title}}</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <div class="input left-icon-input">
                          <label class="icon-left" for="text">
                              <i class="fa fa-calendar"></i>
                          </label>
                          <datepicker input-class="form-control" v-model="temp_activity.start_date" language="zh" @selected="startDateMove" :format="'yyyy-MM-dd'"></datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2" v-if="temp_activity.allDay == false">
                    <div class="form-group">
                      <vue-timepicker v-model="temp_activity.start_time" placeholder="時間" format="HH:mm" :minute-interval="5"></vue-timepicker>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <span style="line-height:39px;font-size:20px;">～</span>
                  </div>
                  <div class="col-md-2" v-if="temp_activity.allDay == false">
                    <div class="form-group">
                      <vue-timepicker v-model="temp_activity.end_time" placeholder="時間" format="HH:mm" :minute-interval="5"></vue-timepicker>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <div class="input left-icon-input">
                          <label class="icon-left" for="text">
                              <i class="fa fa-calendar"></i>
                          </label>
                          <datepicker input-class="form-control" v-model="temp_activity.end_date" language="zh" @selected="startDateMove" :format="'yyyy-MM-dd'"></datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2" v-if="temp_activity.allDay == true">
                    <button @click="temp_activity.allDay=false" class="btn btn-default">增加時間</button>
                  </div>
                </div>
                <p class="alert alert-warning" v-if="temp_activity.time_warning">結束時間必須在開始時間之後</p>
                <div class="row grid-divider">
                  <div class="col-6">
                    <div class="form-group">
                      <div class="input left-icon-input">
                        <label for="text" class="icon-left"><i class="fa fa-tasks"></i></label>
                        <input class="form-control" type="text" placeholder="待辦事項*" v-model="temp_activity.title" name="title" v-validate="'required'">
                        <i v-show="errors.has('title')" class="fa fa-warning"></i>
                        <span v-show="errors.has('title')" class="help is-danger">標題為必填
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea v-autosize="temp_activity.content" rows="3" class="form-control" placeholder="事項備註" v-model="temp_activity.content">{{temp_activity.content}}</textarea>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <div class="input left-icon-input">
                        <label class="icon-left" for="text">
                            <i class="fa fa-user"></i>
                        </label>
                        <select v-model="temp_activity.user_id" class="form-control">
                          <option value="">指派*</option>
                          <option v-for="user in company_users" v-bind:value="user.value">{{user.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="input left-icon-input">
                        <label for="text" class="icon-left"><i class="fas fa-map-marker"></i></label>
                        <input class="form-control" type="text" placeholder="地點" v-model="temp_activity.location">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="btn-group" role="group" aria-label="...">
                        <button type="button" class="btn btn-default" @click="temp_activity.activity_priority='low';" :class="{active: temp_activity.activity_priority === 'low'}"><i class="fa fa-flag" style="color:gray"></i>優先度低</button>
                        <button type="button" class="btn btn-warning" @click="temp_activity.activity_priority='middle';" :class="{active: temp_activity.activity_priority === 'middle'}"><i class="fa fa-flag"></i>優先度中</button>
                        <button type="button" class="btn btn-danger" @click="temp_activity.activity_priority='high';" :class="{active: temp_activity.activity_priority === 'high'}"><i class="fa fa-flag"></i>優先度高</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmit">
                  建立
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template start-->
    <div v-if="showUploadModal" @keyup.esc="showUploadModal=false;">
      <div class="modal-mask">
        <div class="modal-wrapper " @click="showUploadModal=false;">
          <div class="modal-container modal-center col-md-6" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <div class="widget-header margin-bottom-0 clearfix">
                  <h4>上傳檔案</h4>
                </div>
              </div>
              <a href="#" class="btn-close" @click="showUploadModal=false;">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <dropzone 
                id="myVueDropzone" 
                :url="axios.defaults.baseURL + '/activities'" 
                v-on:vdropzone-success="file_uploaded"
                :headers=auth_token
                :maxFileSizeInMB='20'
                >
                <!-- Optional parameters if any! -->
                <input type="hidden" name="deal_token" v-bind:value="this.$route.params.deal_token">
                <input type="hidden" name="activity[deal_id]" v-bind:value="deal.deal_id">
                <input type="hidden" name="activity[user_id]" v-bind:value="user_id">
                <input type="hidden" name="activity[content_type]" value="attachment">
              </dropzone>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import autocomplete from 'vue2-autocomplete-js'
import history from '../Common/History';
import dealHeader from '../Deals/DealHeader';
import activitiesResource from '../Common/ActivitiesResource';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import Dropzone from 'vue2-dropzone'

export default {
  name: 'deal',
  data() {
    return {
      deal: '',
      deal_contact: [],
      deal_activities: [],
      stages: [],
      editColumnName: "",
      editColumnId: "",
      company_users: [],
      temp_activity: {},
      content_type: 'note',
      auth_token: {},
      quotations: [],
      deleteQuotationModal: false,
      changeContactModal: false,
      deal_contact_name: '',
      user_id: '',
      activity_categories: [],
      showNoteModal: false,
      showActivityModal: false,
      showUploadModal: false,
      timeZone:moment.tz.guess(),
    }
  },
  components: {
    Simplert,
    Dropzone,
    autocomplete,
    Datepicker,
    VueTimepicker,
    history,
    activitiesResource,
    dealHeader
  },
  created() {
    this.tempActivityReset()
    this.getDeal(this.$route.params.deal_token)
  },
  props: ['toggle_aside'],
  methods: {
  	canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      // this.$nextTick(() => {
      //   if (Array.isArray(vm.$refs[name+id])){
      //     vm.$refs[name+id][0].focus()
      //   }else{
      //     vm.$refs[name+id].focus()
      //   }
      // })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
    dateSelected(){
    	let vm = this
  		this.$nextTick(() => vm.updateDeal(vm.deal))
    },
    startDateMove: function(date) {
      var days = (new Date(this.temp_activity.end_date) - new Date(this.temp_activity.start_date))/86400000
      var new_start = new Date(date)
      var new_end = new Date(new_start.setDate(new_start.getDate() + days))
      this.temp_activity.end_date = new_end
    },
    loadingQuotation(){
      var obj = {
        isShown: true,
        title: '建立全新報價單中....',
        type: 'info',
        hideAllButton: true
      }
      this.$refs.simplert.openSimplert(obj);
    },
    copyQuotationWording(quotation){
      var obj = {
        isShown: true,
        title: quotation.quotation_title+'複製中，並建立為新的報價單....',
        type: 'info',
        hideAllButton: true
      }
      this.$refs.simplert.openSimplert(obj);
    },
    getDeal(deal_token) {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('deals/show', {
          params: {
            'deal': { 'deal_token': deal_token },
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.temp_activity.deal_id = response['data']['data']['deal']['deal_id']
            vm.user_id = response['data']['data']['user_id']
            vm.deal = response['data']['data']['deal']
            vm.deal_contact = vm.deal.deal_contact
            vm.deal_activities = response['data']['data']['deal_activities']
            vm.stages = response['data']['data']['stages']
            vm.company_users = response['data']['data']['company_users']
            vm.quotations = response['data']['data']['quotations']
            vm.activity_categories = response['data']['data']['activity_categories']
          } else {
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    updateDealOwner(deal){
      // get deal_owner_id
      var user_names = $(this.company_users).map(function(){ return this.name;})
      var new_deal_owner_id = this.company_users[$.inArray(deal.deal_owner, user_names)].value

      const vm = this;
      this.axios.put('deals/update_deal_owner', {
        deal: {
          deal_owner: new_deal_owner_id,
          deal_token: deal.deal_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          console.log(response)
          vm.deal_activities.unshift(response['data']['data']['activity'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    update_deal_status(status) {
      const vm = this;
      this.axios.put('deals/update_deal_status', {
        deal: {
          status: status,
          deal_token: this.deal.deal_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.deal_activities.unshift(response['data']['data']['activity'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    moment() {
      return moment();
    },
    ShowOrganization(organization_token) {
      this.$router.push({ name: 'organization', params: { organization_token: organization_token } })
    },
    ShowContact(contact_token) {
      this.$router.push({ name: 'contact', params: { contact_token: contact_token } })
    },
    tempActivityReset(){
      console.log('reset')
      this.temp_activity={
        id: '',
        title: '',
        content: '',
        start_date: new Date(),
        start_time: {'HH':(new Date()).getHours(),'mm':'00'},
        start:'',
        end_date: new Date(),
        end_time: {'HH':(new Date()).getHours(),'mm':'30'},
        end:'',
        allDay: true,
        location: '',
        user_id: getCookie('filter_deal_owner'),
        deal_id: '',
        content_type: this.content_type,
        contact_id: '',
        activity_status: 0,
        activity_priority: 0,
        activity_category_id: null,
        time_warning: false,
        activity_status: 'doing',
      }
    },
    add_activity() {
      const vm = this;
      var check_time = this.syncTempStartEndDate() 
      this.showNoteModal = false
      this.showActivityModal = false
      this.showUploadModal = false
      if(check_time == false){
        return
      }
      if(vm.activity_content != '') {
        this.axios.post('activities', {
            activity: vm.temp_activity
          })
          .then(function(response) {
            if (response.status == 200) {
              // clear input value
              vm.tempActivityReset()
              vm.deal_activities.unshift(response['data']['data']['activity'])
            } else {
              console.log(response)
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
      }
    },
    syncTempStartEndDate(){
      if(this.temp_activity.ccontent_type != 'event') {
        this.temp_activity.start = null;
        this.temp_activity.end = null;
        return true;
      }

      if(this.temp_activity.allDay == true){
        this.temp_activity.start = moment.tz(this.temp_activity.start_date, this.timeZone).set({hour:0,minute:0,second:0,millisecond:0})
        this.temp_activity.end = moment.tz(this.temp_activity.end_date, this.timeZone).set({hour:0,minute:0,second:0,millisecond:0})
      }else{
        this.temp_activity.start = moment.tz(this.temp_activity.start_date, this.timeZone).set({hour:this.temp_activity.start_time.HH,minute:this.temp_activity.start_time.mm,second:0,millisecond:0})
        this.temp_activity.end = moment.tz(this.temp_activity.end_date, this.timeZone).set({hour:this.temp_activity.end_time.HH,minute:this.temp_activity.end_time.mm,second:0,millisecond:0})
      }

      var a =  this.temp_activity.end - this.temp_activity.start
      if(a < 0){
        this.temp_activity.time_warning = true
        var result = false
      }else{
        var result = true
      }
      //校正因為allDay產生的end day 選擇時，時間多1天的問題
      if(this.temp_activity.allDay == true){
        this.temp_activity.end = this.addDays(new Date(this.temp_activity.end_date),1)
      }
      //如果未來能解決，此段拿掉

      return result
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    updateActivity(activity) {
      const vm = this;
      this.axios.put('activities/update_activity', {
          activity_id: activity.activity_id,
          content: activity.content
        })
        .then(function(response) {
          if (response.status == 200) {} else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    deleteActivity(activity) {
      // delete in html
      var index = this.deal_activities.indexOf(activity)
      this.deal_activities.splice(parseInt(index), 1)
      const vm = this;
      this.axios.delete('activities/delete_activity', {
        params: {
          activity_id: activity.activity_id
        }
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    file_uploaded(file, response){
      this.deal_activities.unshift(response['data']['activity'])
      this.showUploadModal=false
    },
    goAddQuotation(){
      this.$router.push({ name: 'new_quotation', params: { type: 'deal', token:  this.$route.params.deal_token} })
    },
    ShowQuotation(quotation_token) {
      this.$router.push({ name: 'show_quotation', params: { quotation_token: quotation_token } })
    },
    // AutoComplete callback function (Contact)
    process_contact_JSON(json) {
      return json.results.contact;
    },
    handle_contact_Select(data) {
      this.deal_contact_name = data.name
    },
    set_contact_Value(value) {
      this.deal_contact_name = value
    },
    updateDealContact(){
      const vm = this;
      this.axios.put('deals/update_deal_contact', {
        deal: {
          deal_token: vm.deal.deal_token,
          new_contact_name: vm.deal_contact_name
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.changeContactModal = false
          vm.deal_contact = response['data']['data']['deal_contact']
          vm.deal.deal_organization_name = response['data']['data']['deal_organization_name']
          vm.deal.deal_organization_token = response['data']['data']['deal_organization_token']
          vm.deal_activities.unshift(response['data']['data']['activity'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    CreateQuotation(){
      const vm = this;
      this.axios.post('quotations', {
        quotation: {
          deal_token: vm.$route.params.deal_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.ShowQuotation(response['data']['data']['quotation_token'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    updateDeal(deal) {
      const vm = this;
      vm.finishedEditColumn()
      this.axios.put('deals/:id', {
        deal: {
          title: deal.deal_title,
          value: deal.deal_value,
          stage: deal.deal_stage,
          deal_token: deal.deal_token,
          deal_time: deal.deal_time,
        }
      })
      .then(function(response) {
        if (response.status == 200) {
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    copyQuotation(quotation){
      const vm = this;
      this.axios.post('quotations/copy_quotation', {
        quotation_token: quotation.quotation_token
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.ShowQuotation(response['data']['data']['quotation_token'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteQuotationDraft(quotation){
      var index = this.quotations.indexOf(quotation)
      this.quotations.splice(parseInt(index), 1)
      this.deleteQuotationModal = false
      const vm = this;
      this.axios.delete('quotations/delete', {
        params: {
          quotation_token: quotation.quotation_token
        } 
      })
      .then(function(response) {
        if (response.status == 200) {
          console.log('deleted')
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    // for creating activity
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.add_activity();
        } else {
          console.log('fails')
        }
      });
    },
    customFormatter(date) {
    	if(date){
    		moment.locale('zh-tw');
      	return moment(date).format('YYYY MMM Do');
    	}else{
    		return '尚未成交'
    	}
    }
  },
  filters: {
    moment: function(date) {
      moment.locale('zh-tw');
      return moment(date).format('LLL');;
    },
  }
}
</script>
<style>
.inline-edit-input {
  width: 150px !important;
}

.log_content {
  white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// SalesManagement.vue?16477506